import { render, staticRenderFns } from "./WServiceIcon.vue?vue&type=template&id=0de053c3&scoped=true&"
import script from "./WServiceIcon.vue?vue&type=script&lang=js&"
export * from "./WServiceIcon.vue?vue&type=script&lang=js&"
import style0 from "./WServiceIcon.vue?vue&type=style&index=0&id=0de053c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de053c3",
  null
  
)

export default component.exports